// This file is auto-generated. Do not edit!

export default [
  {
    id: "0x4b4406ed8659d03423490d8b62a1639206da0a7a",
    name: "Genesis Vault",
    description:
      "This is the vault for the StakeWise V2 pool. After migrating from StakeWise V2 to V3, you will be staking in this vault. The node operators in this vault are Chorus One, Serenita, and StakeWise Labs.",
  },
  {
    id: "0x2cd404d9d75436e7d6ddbccc2fb9cf7c06941bf1",
    name: "NEDO",
    description:
      "Welcome to the Nedo Vault on StakeWise v3!\n\nWhy Stake with Nedo?\n\nMaximized Returns: Nedo is dedicated to boosting your APY through operational excellence and cost efficiency. We meticulously manage operational costs to enhance your returns and accelerate asset growth.\n\nUncompromised Security: Security is our top priority. We employ cutting-edge measures to safeguard your investments, making Nedo a trusted platform for both institutional and individual investors.\n\nUnwavering Stability: By reinvesting operational fees into our infrastructure, we ensure continuous uptime and reliable performance. Stake with confidence knowing your assets are in steady hands.\n\nTransparency: We believe in openness. Explore our infrastructure in real-time on our transparency dashboard at nedo.fm/gnosis\n\nJoin Nedo Today: Experience secure and profitable staking on the Gnosis Chain with StakeWise v3. Let your assets work harder for you with Nedo.\n\nContact us at: gm@nedo.fm",
  },
  {
    id: "0x00025c729a3364faef02c7d1f577068d87e90ba6",
    name: "Serenita",
    description:
      "Serenita provides enterprise-grade staking services, prioritizing optimal performance while mitigating the risks associated with using majority clients. Our exclusive focus is on the Ethereum ecosystem and we are dedicated to its long-term sustainability and neutrality.\n\nWe manage one of the best StakeWise Vaults on Ethereum, and aim to be a leading staking provider on Gnosis Chain as well.\n\nFor a deeper understanding of our operational approach, visit our website at serenita.io",
  },
  {
    id: "0x34284c27a2304132af751b0dec5bba2cf98ed039",
    name: "0x34284c27a2304132af751b0dec5bba2cf98ed039",
    description: null,
  },
  {
    id: "0x15639e82d2072fa510e5d2b5f0db361c823bcad3",
    name: "0x15639e82d2072fa510e5d2b5f0db361c823bcad3",
    description: null,
  },
  {
    id: "0xf7ee331fe545d25c91977161eed2957c5cffd313",
    name: "NodeHeart - 10% Fee",
    description: "Stake with me!",
  },
  {
    id: "0x0686f6bbb28fd0642aebf5b89654aeba9cc73dea",
    name: "Chorus One",
    description:
      "Chorus One is a trusted staking provider, offering secure and reliable services to individual and institutional stakers alike. Operating on 60+ blockchain networks, we're the choice of over 150,000 delegators worldwide, including leading institutions like BitGo, Ledger, and Hex Trust.\n\nKnown for our enterprise-grade infrastructure and research-driven approach, we've never been slashed and consistently strive to deliver the highest possible yields for our stakers.\n\nStake your GNO with confidence today. Learn more at chorus.one",
  },
  {
    id: "0x809484b8579dc605917b8f94aa284282d5fe375d",
    name: "IP Stake",
    description:
      "I'm a Gnosis Chain solo operator based in Europe since January 2022. I run on-premises high availability setup with 99.9% uptime. I'm a verified nodeset.io operator since June 2024, a verified member of stakersunion.com and a Lido SimpleDVT module mainet operator since July 2024. Stake with me!",
  },
  {
    id: "0x33c346928ed9249cf1d5fc16ae32a8cffa1671ad",
    name: "Axol.io",
    description:
      "Sustainable nodes for gnosis, ran by the LATAM team at Axol.io",
  },
  {
    id: "0xe0a342ed4e0f0dbe97c4810534cfcb6550ea017d",
    name: "Stakecat",
    description:
      "Node operators, securing and decentralizing Ethereum |  AVS operator: http://avs.stakecat.space\n \nWe provide greater decentralization for networks with our own infrastructure for validators and high availability to compete with centralized data center performance.\n\nmore about Stakecat here: https://www.stakecat.space/",
  },
  {
    id: "0xeba0b1524714e50f5844db7f9f821bba08402974",
    name: "nst",
    description: "private, 5% fee, no smoothing",
  },
  {
    id: "0x3cb4692177525db38d983da0445d4eb25c3826de",
    name: "Stakesaurus SEA Home Nodes",
    description:
      "High availability setup using a network of home-based nodes in SEA running minority clients by Stakesaurus' community. Centralised infrastructure is bad for both the network and your own GNO (e.g. cloud service, data centres). Correlation penalties can wipe out your hard-earned yield in the best case and take a sizeable chunk out of your capital in the worst. Our solution? A geographically distributed network of home-staking nodes in Singapore and Malaysia (other SEA locations coming soon!) contributed by the Stakesaurus community. This network of uncorrelated nodes act as fallbacks for one another to provide a high availability staking service! At Stakesaurus, we are growing the solo-staking community in SEA with our open source content — https://linktr.ee/stakesaurus",
  },
  {
    id: "0x27fbf9cc8a4dbf438aecb32f278e287f157a267b",
    name: "alpineforge.eu gnosis vault",
    description:
      "stakewise V3 vault on gnosis, brought to you by alpineforge.eu with <3\nhappy staking! 🦉hoot, hoot!",
  },
  {
    id: "0x39f27264ebaa1e3abf085df3845782d450ac942b",
    name: "Pro Fox",
    description: null,
  },
  {
    id: "0x79dbec2d18a758c62d410f9763956d52fbd4a3cc",
    name: "Stakers.space",
    description:
      "Gnosis Vault by Stakers.space | Fee 10% | Learn more about Gnosis staking at https://stakers.space/gnosis-staking.",
  },
  {
    id: "0x44cc6c8229f1873660012ba36a040b89d83f2cf8",
    name: "SLH",
    description: null,
  },
  {
    id: "0xe275ce985bebf24f30548ab56c66861a802b5598",
    name: " CNC Genesis",
    description:
      "The Gateway to AI & Cloud Sovereignty\n\nCNC brings together powerful staking and real infrastructure built for demanding users. It’s designed to deliver reliability for critical operations and AI-driven workflows.\n\nWhat you get with Genesis vault staking:\n\n- Full AI Agents Suite – Unlock the complete CNC AI Platform, including advanced autonomous AI agents.\n\n- CNC Cloud Suite – Access high-performance Cloud Gaming, secure storage, and computing resources.\n\n- VIP Membership – Eligibility for private ultra-low-fee vaults and priority technical support.\n\nGenesis vault powers the CNC ecosystem, combining premium staking with next-generation decentralized intelligence.\n\nTo activate your Premium access (Cloud & AI) after staking, contact our team at joecnc@proton.me",
  },
  {
    id: "0x8a20669daa7969788f0ae7dbd38ac76e102ef213",
    name: "FCC GNO Vault",
    description: "FCC GNO Liquid Staking Public Vault",
  },
  {
    id: "0x1f87105abbd23b49f2abf0995b21b52b97aacdc4",
    name: "AI IA Private Vault",
    description: null,
  },
  {
    id: "0x745847818a5790cb406c3040a386907559869be2",
    name: " CNC Core - 9% Fee",
    description:
      "Industrial-Grade Staking & Performance\n\nPerformance Focused. Yield Optimized. CNC Core vault is powered by our Tier-1 enterprise infrastructure: ultra-fast fiber connectivity, NVMe SSD storage, and dedicated UPS redundancy. It is engineered for stakers who prioritize technical stability and maximum net rewards.\n\nCore Features:\n\n- Tier-1 Infrastructure : Runs on the same high-performance hardware and network as our Genesis Vault.\n- Uptime : Continuous 24/7 monitoring by on-call engineers for immediate intervention.\n- Fee Structure : A streamlined 9% fee designed to maximize your staking APR by removing additional software layers.\n\nThe strategic choice for dedicated stakers seeking professional-grade hardware and a minimal fee \nfootprint.",
  },
  {
    id: "0xc554bdbbed28d34e3675c6c53dc0ab645cf285e0",
    name: "Wunode",
    description: "Dappnode vault, fiber gigabit uplink, UPS",
  },
  {
    id: "0x1f7e70d661279a8bb657417bbc71b82b948752b2",
    name: "Dappnode Test 2",
    description: null,
  },
  {
    id: "0xb221ea4b710043f3530d2bc912dbef6cab2b5c3d",
    name: "Day One Law Team&Client Vault",
    description:
      "At Day One Law, we don’t just advise on crypto—we use the products, run the infrastructure, and stake on-chain alongside our clients. Our private Stakewise vault on Gnosis Chain is exclusively for our clients and team members, reinforcing our commitment to supporting the ecosystems that matter.\n\nIf you’re already working with us, you’re in. If not, and you’re looking for a legal partner who actually understands the tech, uses the protocols, and aligns with builders and investors in the space, let’s talk.\n\nWe support founders, investors, and operators pushing crypto forward—structuring their projects, securing regulatory clarity, and aligning incentives for long-term success. Our clients get real legal and strategic value, plus access to exclusive opportunities like this.\n\nWe’re not just advisors—we’re on-chain, active participants in the same products and protocols shaping the future of decentralized finance. If that’s the kind of partner you want, reach out.",
  },
] as const
